import { useEffect, useState } from "react";
import { Button, Card, Space, Typography } from "antd";
import "./UpcomingEvents.css";
import { EventDateDisaply } from "../DateDisplay";
import SessionActions from "../Session/SessionActions";
import { useUserEvents } from "../../api/Events";
import Loading from "../Loading";
import { useNavigate } from "react-router-dom";

const UpcomingEvents = () => {
  const [events, setEvents] = useState([]);
  const { data, isLoading } = useUserEvents(5);

  useEffect(() => {
    let eventData = [];
    if (data?.sessions) {
      data.sessions.forEach((e) => eventData.push(sessionEvent(e)));
    }
    if (data?.courses) {
      data.courses.forEach((e) => eventData.push(courseEvent(e)));
    }
    setEvents(eventData);
  }, [data]);

  return isLoading ? (
    <Loading />
  ) : (
    <Card
      style={{ height: "100%" }}
      title={<Typography.Title level={5}>Upcoming Events</Typography.Title>}
    >
      {!events || (events.length === 0 && <EmptyEvents />)}
      {events.map((event) => (
        <Event event={event} key={event.eventId} />
      ))}
    </Card>
  );
};

const courseEvent = (course) => {
  const event = {
    date: course?.StartTime,
    end: course?.EndTime,
    type: "course",
    title: course?.Name,
    description: course?.Description,
    eventId: course?.CourseId,
  };

  return event;
};

const sessionEvent = (session) => {
  const event = {
    date: session?.StartTime,
    end: session?.EndTime,
    type: "session",
    title: `${session?.Category} Session`,
    description: session?.Note,
    eventId: session?.SessionId,
  };

  return event;
};

const EmptyEvents = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        height: "100%",
        textAlign: "center",
      }}
    >
      <Typography.Paragraph type="secondary">
        When you schedule sessions or register for classes they will appear
        here.
      </Typography.Paragraph>
      <Button type="primary" onClick={() => navigate("/caregivers")}>
        Browse Caregivers
      </Button>
    </div>
  );
};

const Event = ({ event }) => {
  return (
    <div className="upcoming-event">
      <div className="cell">
        <EventDateDisaply start={event.date} end={event.end} />
      </div>
      <div className="cell">
        <Typography.Title level={5}>{event.title}</Typography.Title>
        {/* <Typography.Text type="secondary">
          {event?.description?.substring(0, 100)}
        </Typography.Text> */}
      </div>
      <div className="cell" style={{ marginLeft: "auto" }}>
        <Space direction="vertical">
          <SessionActions
            session={{
              StartTime: event.date,
              EndTime: event.end,
              Status: "accepted",
            }}
          />
        </Space>
      </div>
    </div>
  );
};

export default UpcomingEvents;
